module.exports = __webpack_public_path__ + "static/icons/informa.fce6bf6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/character/informa.svg
// module id = x31t
// module chunks = 1